import React, { useState } from "react";
import { Image, Modal, Button } from "react-bootstrap";

const Filter = (props) => {
  // const [state, setState] = useState({
  //   open: false,
  // });
  // const onOpenModal = () => {
  //   setState({ open: true });
  // };
  // const handleCloseModal = () => {
  //   setState({ open: false });

  // };
  const [showexpfilter,setshow]=useState(false);

  return (
    <React.Fragment>
      <div
        onClick={props.onOpenModal}
        className="d-flex align-items-center justify-content-between cursor"
      >
        <Image
          alt="filter"
          title="filter"
          width="80px"
          src={require("../../../assets/images/seatingImages/filter.svg")}
        />
        {/* <div className="f12-500 text-blue mx-2">Filter</div>
        <i className="fa fa-angle-down text-blue" aria-hidden="true"></i> */}
      </div>
      <Modal show={props.open} onHide={props.handleCloseModal} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title className="f24_700_HelveticaNeue">Filter</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center pb-4">
            <label className="enRadioWithText f16-500 mr-4">
              Ratings
              <input
                type="radio"
                name="CouponDiscountType"
                checked={props.ratingChecked}
                onChange={props.ratingCheckedClick}
              />
              <span className="checkmark"></span>
            </label> 
            {props?.exptypefilter && (<>
              <label className="enRadioWithText f16-500 mr-4">
              Experience Type
              <input
                type="radio"
                name="expfilter"
                checked={props?.expcheck}
                onChange={props?.ratingCheckedClick}
              />
              <span className="checkmark"></span>
            </label>
            </>)}
            {props.serviceChecked === true ? (<>
              <label className="enRadioWithText f16-500 mr-4">
              Service
              <input
                type="radio"
                name="CouponDiscountType"
                checked={props.serviceChecked}
                onChange={props.ratingCheckedClick}
              />
              <span className="checkmark"></span>
            </label>
            </>) : null}

          </div>
          <div className="f16-500 pb-4">
            Select one relevant option from below
          </div>
          {props.ratingChecked === true ? (
            <div className="d-flex flex-wrap align-items-center">
              <div
                className="enCheckWithText mr-3"
                onClick={props.onHendleClick(0)}
              >
                <input type="radio" name="OfferType" />
                <label>All</label>
              </div>
              <div
                className="enCheckWithText mr-3"
                onClick={props.onHendleClick(5)}
              >
                <input type="radio" name="OfferType" />
                <label>5 Star</label>
              </div>
              <div
                className="enCheckWithText mr-3"
                onClick={props.onHendleClick(4)}
              >
                <input type="radio" name="OfferType" />
                <label>4 Star</label>
              </div>
              <div
                className="enCheckWithText mr-3"
                onClick={props.onHendleClick(3)}
              >
                <input type="radio" name="OfferType" />
                <label>3 Star</label>
              </div>
              <div
                className="enCheckWithText mr-3"
                onClick={props.onHendleClick(2)}
              >
                <input type="radio" name="OfferType" />
                <label>2 Star</label>
              </div>
              <div
                className="enCheckWithText mr-3"
                onClick={props.onHendleClick(1)}
              >
                <input type="radio" name="OfferType" />
                <label>1 Star</label>
              </div>
            </div>
          ) : null}
          {props.serviceChecked === true ? (
            <div className="d-flex flex-wrap align-items-center">
              <div className="enCheckWithText mr-3">
                <input type="radio" name="Status" />
                <label>All</label>
              </div>
              <div className="enCheckWithText mr-3">
                <input type="radio" name="Status" />
                <label>Walk-in</label>
              </div>
              <div className="enCheckWithText mr-3">
                <input type="radio" name="Status" />
                <label>Wait list</label>
              </div>
              <div className="enCheckWithText mr-3">
                <input type="radio" name="Status" />
                <label>Reservation</label>
              </div>
            </div>
          ) : null}
                    {props?.expcheck=== true ? (
            <div className="d-flex flex-wrap align-items-center">
              <div className="enCheckWithText mr-3" onClick={props?.onclickfilter("all")}>
                <input type="radio" name="Status" />
                <label>All</label>
              </div>
              <div className="enCheckWithText mr-3" onClick={props?.onclickfilter("SPECIAL")}>
                <input type="radio" name="Status" />
                <label>Occasions</label>
              </div>
              <div className="enCheckWithText mr-3" onClick={props?.onclickfilter("CURATED")}>
                <input type="radio" name="Status" />
                <label>Events</label>
              </div>

            </div>
          ) : null}
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={props.handleReset}
          >
            Reset Filter
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={props.handleCloseModal}
          >
            Apply Filter
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};
export default Filter;
